import React, { useContext } from 'react'
import ReactPaginate from 'react-paginate'
import SearchContext from 'modules/react/search/SearchContext'

export default function Pagination () {

  const { page, goToPage, pageCount } = useContext(SearchContext)

  const handlePageClick = (event) => {
    goToPage(event.selected + 1)
  }


  if(pageCount <= 1) {
    return null
  }

  return (
    <ReactPaginate
      previousLabel="<"
      nextLabel=">"
      pageClassName="page-item"
      pageLinkClassName="page-link"
      previousClassName="page-item"
      previousLinkClassName="page-link"
      nextClassName="page-item"
      nextLinkClassName="page-link"
      breakLabel="..."
      breakClassName="page-item"
      breakLinkClassName="page-link"
      pageCount={pageCount}
      marginPagesDisplayed={2}
      pageRangeDisplayed={5}
      onPageChange={handlePageClick}
      containerClassName="pagination"
      activeClassName="active"
      forcePage={page - 1}
      renderOnZeroPageCount={null}
    />
  )
}